import { useAuth } from "../AuthProvider";

/**
 * Hook für permission-basierte Berechtigungen pro Seite.
 * Prüft Auth0 Permissions aus dem Access Token.
 */
export const usePagePermissions = (pageName: string) => {
  const { user } = useAuth();

  const userPermissions = user?.permissions || [];

  const pagePermissionMapping: Record<string, { view: string; edit: string }> =
    {
      "project-overview": { view: "projects:read", edit: "projects:write" },
      "project-company": { view: "companies:read", edit: "companies:write" },
      // Alle Seiten des Moduls Genehmigung teilen sich eine Berechtigung – wer Anträge
      // sehen darf, sieht auch deren Nachweise und Kosten.
      "project-permit-applications": {
        view: "permits:read",
        edit: "permits:write",
      },
      "project-permit-elia": { view: "permits:read", edit: "permits:write" },
      "project-permit-evidences": {
        view: "permits:read",
        edit: "permits:write",
      },
      "project-permit-costs": { view: "permits:read", edit: "permits:write" },
      "project-area": { view: "projects:read", edit: "projects:write" },
      "project-generation-units": {
        view: "projects:read",
        edit: "projects:write",
      },
      "project-yield": {
        view: "yield_forecasts:read",
        edit: "yield_forecasts:write",
      },
      "project-costs": { view: "costs:read", edit: "costs:write" },
      "project-revenues": { view: "tariffs:read", edit: "tariffs:write" },
      "project-financing": {
        view: "financings:read",
        edit: "financings:write",
      },
      "project-calculation": {
        view: "calculations:read",
        edit: "calculations:write",
      },
    };

  const pagePermissions = pagePermissionMapping[pageName];

  if (!pagePermissions) {
    return {
      canView: false,
      canEdit: false,
      requiredViewPermission: "",
      requiredEditPermission: "",
    };
  }

  const canView = userPermissions.includes(pagePermissions.view);
  const canEdit = userPermissions.includes(pagePermissions.edit);

  return {
    canView,
    canEdit,
    requiredViewPermission: pagePermissions.view,
    requiredEditPermission: pagePermissions.edit,
  };
};
